import styled from "styled-components";

export const ToggleButton = styled.button`
  display: none;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;

  svg {
    transition: stroke 0.2s ease;
  }

  &:hover svg {
    stroke: ${({ theme }) => theme.button.bg.primary};
  }

  @media (max-width: 768px) {
    display: block;
  }
`;
